export default __webpack_public_path__ + "static/media/complementary--tow-away-zone--g1.8e752887.png";